import React from 'react';
import { AppBar, HeaderTabs, ScrollableViewport } from '@ihsm/ui-shared';
import { PageContent } from 'shared/components/PageContent';
import { InnerPagePadding } from 'shared/components/InnerPagePadding';
import { PortfoliosMappingTable } from '../components/PortfoliosMappingTable/PortfoliosMappingTable';
import { usePortfolioPage } from '../hooks';
import { Controls } from '../components/Controls';
import { FUNDS_TABS, MAPPING_PAGE_OPTIONS } from '../constants';

export const PortfoliosMapping: React.FC = (): JSX.Element => {
  const { exporterRef, onExport } = usePortfolioPage();

  return (
    <PageContent
      headerControls={
        <AppBar menuItems={MAPPING_PAGE_OPTIONS}>
          <HeaderTabs items={FUNDS_TABS} />
        </AppBar>
      }
      viewControls={<Controls onExport={onExport} />}
    >
      <InnerPagePadding>
        <ScrollableViewport vertical>
          <PortfoliosMappingTable gridExportRef={exporterRef} />
        </ScrollableViewport>
      </InnerPagePadding>
    </PageContent>
  );
};
